var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFootprintActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3555_280803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2188 15.0446C25.9358 14.2077 23.9119 13.5815 22.4567 14.2353C21.9715 14.4535 21.5494 14.8141 21.2391 15.3564C20.7433 16.2235 20.6798 17.2883 20.8621 18.2725C21.1818 20.0012 22.1644 21.5157 22.4889 23.2486C22.7893 24.8538 22.5227 26.327 21.4632 27.5891C20.4442 28.8031 19.8997 30.3498 20.0115 31.9553C20.0549 32.5789 20.1985 33.2061 20.5179 33.7416C20.8849 34.357 21.4612 34.7527 22.1444 34.9293C24.0514 35.4218 25.0642 33.2327 25.5439 31.7602C26.2049 29.7307 26.3401 27.5299 27.3092 25.6045C27.9084 24.4136 28.8054 23.3917 29.3691 22.1835C30.5562 19.639 29.541 16.56 27.2188 15.0449V15.0446Z",
    fill: "#4E84C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4531 13.365C23.3928 13.3563 24.145 12.3077 24.1332 11.0229C24.1215 9.73821 23.3501 8.70384 22.4104 8.71262C21.4708 8.7214 20.7185 9.76999 20.7303 11.0547C20.7421 12.3395 21.5134 13.3738 22.4531 13.365Z",
    fill: "#4E84C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9231 12.244C27.1965 11.3016 26.886 10.3802 26.2295 10.1859C25.5731 9.99171 24.8193 10.5982 24.5459 11.5407C24.2724 12.4831 24.5829 13.4045 25.2394 13.5988C25.8958 13.793 26.6496 13.1864 26.9231 12.244Z",
    fill: "#4E84C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9463 13.9246C29.3823 13.2668 29.3644 12.4826 28.9064 12.1729C28.4483 11.8633 27.7236 12.1455 27.2875 12.8032C26.8515 13.4609 26.8694 14.2452 27.3274 14.5548C27.7855 14.8645 28.5103 14.5823 28.9463 13.9246Z",
    fill: "#4E84C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8393 15.6702C29.1072 15.9533 29.6474 15.8714 30.0463 15.4868C30.4452 15.1025 30.5512 14.5611 30.2833 14.2779C30.0154 13.9948 29.4752 14.0767 29.0763 14.4613C28.6774 14.8456 28.5715 15.387 28.8393 15.6702Z",
    fill: "#4E84C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2136 16.1074C30.9854 15.8398 30.5082 15.8769 30.1476 16.1907C29.7871 16.5041 29.6798 16.9752 29.9078 17.2431C30.1361 17.5107 30.6132 17.4736 30.9738 17.1599C31.3344 16.8464 31.4416 16.3753 31.2136 16.1074Z",
    fill: "#4E84C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5113 17.5349C15.8358 15.8017 16.8184 14.2875 17.1381 12.5588C17.3203 11.5747 17.2569 10.5099 16.7611 9.64273C16.4507 9.10009 16.0287 8.73984 15.5435 8.52168C14.0882 7.86752 12.0647 8.49372 10.7814 9.33093C8.45883 10.846 7.4437 13.925 8.63107 16.4695C9.19482 17.678 10.0918 18.6999 10.6909 19.8905C11.66 21.8159 11.7953 24.0168 12.4562 26.0465C12.9356 27.5191 13.9488 29.7082 15.8558 29.2156C16.539 29.039 17.1153 28.6434 17.4823 28.0279C17.8017 27.4924 17.9453 26.8652 17.9887 26.2416C18.1008 24.6361 17.5563 23.0895 16.537 21.8754C15.4775 20.6133 15.2109 19.1401 15.5113 17.5349Z",
    fill: "#4E84C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2709 5.34181C17.2827 4.05708 16.5305 3.00849 15.5908 2.99971C14.6511 2.99093 13.8798 4.02529 13.868 5.31002C13.8562 6.59475 14.6085 7.64335 15.5481 7.65213C16.4878 7.6609 17.2592 6.62654 17.2709 5.34181Z",
    fill: "#4E84C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7627 7.8834C13.4192 7.68917 13.7297 6.76773 13.4563 5.82531C13.1828 4.88289 12.429 4.27636 11.7726 4.47059C11.1161 4.66481 10.8056 5.58625 11.0791 6.52867C11.3525 7.47109 12.1063 8.07762 12.7627 7.8834Z",
    fill: "#4E84C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.674 8.83878C11.132 8.52912 11.1499 7.74488 10.7139 7.08714C10.2778 6.4294 9.55305 6.14722 9.095 6.45689C8.63695 6.76655 8.61909 7.55078 9.05511 8.20853C9.49113 8.86627 10.2159 9.14844 10.674 8.83878Z",
    fill: "#4E84C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16212 9.95566C9.4299 9.67239 9.32376 9.13115 8.92505 8.74678C8.52634 8.36241 7.98604 8.28046 7.71826 8.56374C7.45048 8.84702 7.55662 9.38825 7.95533 9.77262C8.35404 10.157 8.89434 10.2389 9.16212 9.95566Z",
    fill: "#4E84C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09202 11.5287C8.32024 11.261 8.21294 10.7899 7.85236 10.4764C7.49179 10.1628 7.01448 10.1256 6.78626 10.3933C6.55805 10.661 6.66535 11.1321 7.02593 11.4456C7.3865 11.7592 7.86381 11.7964 8.09202 11.5287Z",
    fill: "#4E84C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3555_280803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.6667,
    height: 32,
    fill: "white",
    transform: "translate(6.66699 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootprintActive);
export default __webpack_public_path__ + "static/media/footprint_active.615644b821c85c8842eec92dff1a6614.svg";
export { ForwardRef as ReactComponent };